import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { AgentMeta } from "tekkr-common/dist/model/agent/agent";

export function useListAgentsQuery() {
    return useQuery({
        queryKey: ["agents"],
        queryFn: async (): Promise<AgentMeta[]> => {
            const res = await apiClient.listAgents();
            if (res.status !== 200) {
                throw new Error("Error fetching agents");
            }
            return res.body.data;
        },
    });
}
